import { render, staticRenderFns } from "./UserPerfil.vue?vue&type=template&id=6a4e9f64&scoped=true"
import script from "./UserPerfil.vue?vue&type=script&lang=js"
export * from "./UserPerfil.vue?vue&type=script&lang=js"
import style0 from "./UserPerfil.vue?vue&type=style&index=0&id=6a4e9f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4e9f64",
  null
  
)

export default component.exports